import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from '@redux-saga/core';

import SystemReducer from './slices/system/system.slice';
import ProgrammeReducer from './slices/programme/programme.slice';
import PlanReducer from './slices/programme/plan/plan.slice';
import AccountabilityReducer from './slices/programme/accountability/accountability.slice';
import SupportReducer from './slices/programme/support/support.slice';
import MemberReducer from './slices/programme/member/member.slice';
import TribeReducer from './slices/programme/tribe/tribe.slice';
import RegistrationReducer from './slices/registration/registration.slice';
import TeamReducer from './slices/programme/team/team.slice';

import loginSaga from './api/login/login.saga';
import programmeSaga from './api/programme/programme.saga';
import collectionSaga from './api/collection/collection.saga';
import resourceSaga from './api/resource/resource.saga';
import accountabilityTemplateSaga from './api/accountability-template/accountability-template.saga';
import supportTemplateSaga from './api/support-template/support-template.saga';
import memberSaga from './api/member/member.saga';
import tribeTemplateSaga from './api/tribe-template/tribe-template.saga';
import systemUserSaga from './api/system-user/system-user.saga';
import documentSaga from './api/document/document.saga';
import leaderboardSaga from './api/leaderboard/leaderboard.saga';
import supportSaga from './api/support/support.saga';
import postSaga from './api/post/post.saga';
import reactionSaga from './api/reaction/reaction.saga';
import commentSaga from './api/comment/comment.saga';
import administrationSaga from './api/administration/administration.saga';
import approvalSaga from './api/approval/approval.saga';
import notificationSaga from './api/notification/notification.saga';
import pollSaga from './api/poll/poll.saga';
import registrationSaga from './api/registration/registration.saga';
import externalRegistrationSaga from './api/external-registration/external-registration.saga';
import teamSaga from './api/team/team.saga';
import teamMemberSaga from './api/team-member/team-member.saga';
import programmeTeamsSaga from './api/programme-teams/programme-teams.saga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    system: SystemReducer,
    programme: ProgrammeReducer,
    plan: PlanReducer,
    accountability: AccountabilityReducer,
    support: SupportReducer,
    member: MemberReducer,
    tribe: TribeReducer,
    registration: RegistrationReducer,
    team: TeamReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(sagaMiddleware)
});

sagaMiddleware.run(loginSaga);
sagaMiddleware.run(programmeSaga);
sagaMiddleware.run(collectionSaga);
sagaMiddleware.run(resourceSaga);
sagaMiddleware.run(accountabilityTemplateSaga);
sagaMiddleware.run(supportTemplateSaga);
sagaMiddleware.run(memberSaga);
sagaMiddleware.run(tribeTemplateSaga);
sagaMiddleware.run(systemUserSaga);
sagaMiddleware.run(documentSaga);
sagaMiddleware.run(leaderboardSaga);
sagaMiddleware.run(supportSaga);
sagaMiddleware.run(postSaga);
sagaMiddleware.run(reactionSaga);
sagaMiddleware.run(commentSaga);
sagaMiddleware.run(administrationSaga);
sagaMiddleware.run(approvalSaga);
sagaMiddleware.run(notificationSaga);
sagaMiddleware.run(pollSaga);
sagaMiddleware.run(registrationSaga);
sagaMiddleware.run(externalRegistrationSaga);
sagaMiddleware.run(teamSaga);
sagaMiddleware.run(teamMemberSaga);
sagaMiddleware.run(programmeTeamsSaga);
